<ng-container *ngIf="{ darkMode: darkMode$ | async } as ui">
<div class="login-page container-fluid d-flex justify-content-center align-items-center vh-100"
  [ngClass]="{'bg-dark-900': ui.darkMode}">
  <div class="login-panel col-lg-4 col-md-5 col-sm-7 col-12" *ngIf="loginForm">

    <div class="d-flex align-items-center justify-content-between mb-2">
      <h3 class="font-weight-bold mb-0" [ngClass]="{'text-primary': !ui.darkMode, 'text-primary-light': ui.darkMode}">
        Admin
      </h3>
      <span class="badge env-badge" [ngClass]="env.isLive ? 'badge-danger' : 'badge-info'"
        [ngbTooltip]="env.apiUrl" placement="left">
        <i class="fas" [ngClass]="env.isLive ? 'fa-exclamation-triangle' : 'fa-code-branch'"></i>
        {{ env.label }}
      </span>
    </div>
    <p class="text-secondary mb-3">Login using your normal Members' Area credentials.</p>

    <div class="card login-card" [ngClass]="{'bg-dark text-dark-600 border-dark-700': ui.darkMode}">
      <div class="card-body p-4">
        <form [formGroup]="loginForm" id="loginForm" (ngSubmit)="login()" novalidate>

          <div class="form-group">
            <label for="username">Username</label>
            <input id="username" formControlName="username" type="text" class="form-control"
              autocomplete="username" autofocus
              [ngClass]="{
                'text-light bg-dark-900 border-dark-700': ui.darkMode,
                'is-invalid': loginForm.get('username').touched && loginForm.get('username').invalid
              }">
            <div class="invalid-feedback">Enter your username.</div>
          </div>

          <div class="form-group">
            <label for="password">Password</label>
            <div class="input-group">
              <input id="password" formControlName="password" [type]="showPassword ? 'text' : 'password'"
                class="form-control" autocomplete="current-password"
                [ngClass]="{
                  'text-light bg-dark-900 border-dark-700': ui.darkMode,
                  'is-invalid': loginForm.get('password').touched && loginForm.get('password').invalid
                }">
              <div class="input-group-append">
                <button type="button" class="btn btn-outline-secondary password-toggle"
                  (click)="toggleShowPassword()"
                  [ngbTooltip]="showPassword ? 'Hide password' : 'Show password'">
                  <i class="fas" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                </button>
              </div>
            </div>
            <small *ngIf="loginForm.get('password').touched && loginForm.get('password').invalid"
              class="form-text text-danger">Enter your password.</small>
          </div>

          <button type="submit" class="btn btn-success btn-block" [disabled]="loginLoading || loginForm.invalid">
            <span *ngIf="loginLoading">
              <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
              Logging in...
            </span>
            <span *ngIf="!loginLoading">Login</span>
          </button>
        </form>

        <div *ngIf="loginError" class="alert alert-danger mb-0 mt-3" role="alert">
          {{ loginError }}
        </div>
      </div>
    </div>

  </div>
</div>
</ng-container>
